<template>
  <div>
    <ul v-for="(pair, i) in pairs">
      <li @click="removePair(i)">{{ `${keyLabel}: ${pair[keyLabel]}, ${valueLabel}: ${pair[valueLabel]}` }}</li>
    </ul>
    <div>
      <input type="text" name="key" v-model="inputKey" :placeholder="keyLabel">
      <input type="text" name="value" v-model="inputValue" :placeholder="valueLabel">
      <button @click="addPair">Add</button>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import Draggable from 'vuedraggable'
export default {
  components: { Draggable },

  props: ['value', 'key-label', 'value-label'],

  data () {
    return {
      inputKey: '',
      inputValue: ''
    }
  },

  computed: {
    pairs () {
      return this.value
    }
  },

  methods: {
    addPair () {
      let pair = {}
      pair[this.keyLabel] = this.inputKey
      pair[this.valueLabel] = this.inputValue
      this.$emit('input', [...this.pairs, pair])
      this.inputKey = ''
      this.inputValue = ''
    },

    removePair (i) {
      const pairs = JSON.parse(JSON.stringify(this.pairs)) // clone pairs so we dont mutate prop
      pairs.splice(i, 1);
      this.$emit('input', pairs)
    }
  }

}
</script>
<style lang="scss">
</style>